import { ACTION_TYPES } from '../../constants/store.constants';

const initialState = {
  currentTabContext: null,
  selectedTab: null
};

const TabReducer = (state, { type, payload } = {}) => {
  if (!state) state = initialState;
  switch (type) {
    case ACTION_TYPES.SET_CURRENT_TAB_CONTEXT:
      return {
        ...state,
        currentTabContext: payload
      };
    case ACTION_TYPES.FETCH_APP_SETTINGS_SUCCESS:
      return {
        ...state
      };
    case ACTION_TYPES.UPDATE_MOBILEVIEW_MATRIX:
      return {
        ...state,
        selectedTab: payload
      };

    default:
      return state;
  }
};

export default TabReducer;
